import { Form, Select } from "antd";

const { Item } = Form;
const { Option } = Select;

const BlogSelector = ({
  name,
  label,
  placeholder,
  basicBlogDetailsList,
  onFieldClear
}) => {
  return (
    <Item name={name} label={label}>
      <Select
        allowClear
        placeholder={placeholder}
        optionFilterProp="children"
        showSearch
        onClear={() => onFieldClear?.(name)}
      >
        {basicBlogDetailsList.map((blogDetails) => (
          <Option
            key={blogDetails.activeUniqueUrlIdentifier}
            value={blogDetails.activeUniqueUrlIdentifier}
          >
            {blogDetails.title}
          </Option>
        ))}
      </Select>
    </Item>
  );
};

export default BlogSelector;
